import React, { Fragment } from 'react'
import '../main/main.css';
import My_image from '../main/assets2/7.jpg';



const FrontPage = ()=>{
    return (

        <>
         <div className="main_photo">
            <img src={My_image} alt="Jewelery" />

         </div>
        
        </>
      );

};


export default FrontPage;
